import type { Firestore } from 'firebase/firestore';
import { pageViewLogService } from '../data/services';
import { v4 as uuidv4 } from 'uuid';
const setPageView = async (
  firestore: Firestore,
  uid: string,
  pageUrl: string,
): Promise<void> => {
  pageViewLogService.updateData(firestore, uuidv4(), { uid, pageUrl });
};

export default setPageView;
